import styled from 'styled-components';
import type { CaseRecord } from '@/core/models/case';
import { CaseRow } from './CaseRow';

const Empty = styled.p`
  color: ${({ theme }) => theme.color.textMuted};
  font-size: ${({ theme }) => theme.fontSize.sm};
  padding: 24px 0;
`;

export function CaseList({ cases, emptyLabel = 'No cases in this view.' }: { cases: CaseRecord[]; emptyLabel?: string }) {
  if (cases.length === 0) return <Empty>{emptyLabel}</Empty>;
  return <div>{cases.map((c) => <CaseRow key={c.id} c={c} />)}</div>;
}
